(() => {
  if (window.self !== window.top && !(window.Shopify && window.Shopify.designMode)) return;
  const root = document.querySelector('[data-kiki-popup]');
  if (!root) return;

  const tab = root.querySelector('[data-kiki-open]');
  const tabWrap = root.querySelector('[data-kiki-tab-wrap]');
  const tabClose = root.querySelector('[data-kiki-tab-close]');
  const popupOpenTriggers = document.querySelectorAll('[data-kiki-popup-open]');
  const dialog = root.querySelector('[data-kiki-dialog]');
  const overlay = root.querySelector('[data-kiki-overlay]');
  const closeButtons = root.querySelectorAll('[data-kiki-close]');
  const form = root.querySelector('form');
  const asyncResult = root.querySelector('[data-kiki-async-result]');
  const asyncSuccess = root.querySelector('[data-kiki-async-success]');
  const asyncSuccessCopy = root.querySelector('[data-kiki-async-success-copy]');
  const asyncApply = root.querySelector('[data-kiki-async-apply]');
  const emailInput = form ? form.querySelector('input[type="email"]') : null;
  const submitButton = form ? form.querySelector('button[type="submit"]') : null;
  if (!tab || !dialog || !overlay) return;

  const delay = Math.max(0, Number(root.dataset.delay || 60000));
  const dailyLimit = Math.max(0, Number(root.dataset.dailyLimit || 1));
  const passivePage = Boolean(document.querySelector('[data-kiki-popup-passive]'));
  const suppressAutoOpen = passivePage || /^\/pages\/companion-care\/?$/.test(window.location.pathname);
  const claimedKey = 'kiki_magic_claimed';
  const seenPrefix = 'kiki_popup_seen_';
  const dismissedKey = 'kiki_popup_tab_dismissed';
  let dismissedThisVisit = false;
  try {
    dismissedThisVisit = window.sessionStorage.getItem(dismissedKey) === '1';
  } catch (error) {}
  let lastFocused = null;
  let autoOpened = false;

  const dismissTab = () => {
    dismissedThisVisit = true;
    try {
      window.sessionStorage.setItem(dismissedKey, '1');
    } catch (error) {}
    if (tabWrap) {
      tabWrap.hidden = true;
      tabWrap.setAttribute('aria-hidden', 'true');
    }
    if (tabClose) tabClose.blur();
  };

  const todayKey = () => {
    const now = new Date();
    return seenPrefix + now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  };

  const storageGet = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const storageSet = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return false;
    }
    return true;
  };

  const hasClaimed = () => storageGet(claimedKey) === '1';

  const dailyCount = () => {
    const value = Number(storageGet(todayKey()) || 0);
    return Number.isFinite(value) ? value : 0;
  };

  const markAutoShown = () => storageSet(todayKey(), String(dailyCount() + 1));

  const focusable = () => dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]');
  const focusFirst = () => {
    const items = focusable();
    if (items.length) items[0].focus();
  };

  const open = (source) => {
    lastFocused = document.activeElement;
    dialog.hidden = false;
    overlay.hidden = false;
    root.hidden = false;
    tab.setAttribute('aria-expanded', 'true');
    document.body.classList.add('kiki-popup-open');
    focusFirst();
    if (source === 'auto') {
      autoOpened = true;
      markAutoShown();
    }
  };

  const close = () => {
    dialog.hidden = true;
    overlay.hidden = true;
    tab.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('kiki-popup-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  const onKeydown = (event) => {
    if (event.key === 'Escape' && !dialog.hidden) {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab' || dialog.hidden) return;
    const items = Array.from(focusable());
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const markClaimed = () => {
    storageSet(claimedKey, '1');
    root.dataset.formSuccess = 'true';
  };

  tab.addEventListener('click', () => open('manual'));
  popupOpenTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      open('manual');
    });
  });
  if (tabClose) {
    tabClose.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      dismissTab();
    });
  }
  overlay.addEventListener('click', close);
  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', onKeydown);

  let submissionState = 'idle';
  let submissionId = 0;
  let resultFrame = null;
  let resultTimer = null;
  let submittedThisVisit = false;

  const showAsyncSuccess = () => {
    if (emailInput) emailInput.hidden = true;
    if (submitButton) {
      submitButton.hidden = true;
      submitButton.disabled = true;
    }
    form.removeAttribute('aria-busy');
    if (asyncResult) asyncResult.hidden = false;
    if (asyncSuccess) asyncSuccess.hidden = false;
    if (asyncSuccessCopy) asyncSuccessCopy.hidden = false;
    if (asyncApply) {
      asyncApply.hidden = false;
      if (!dialog.hidden) asyncApply.focus();
    }
  };

  const clearResultTimer = () => {
    if (resultTimer) window.clearTimeout(resultTimer);
    resultTimer = null;
  };

  const removeResultFrame = () => {
    if (resultFrame) resultFrame.remove();
    resultFrame = null;
  };

  const settleSubmission = (confirmed) => {
    clearResultTimer();
    submissionState = confirmed ? 'confirmed' : 'unconfirmed';
    form.dataset.kikiAsyncSubmitting = submissionState;
    if (confirmed) {
      markClaimed();
      removeResultFrame();
    }
  };

  const prepareResultFrame = (attempt) => {
    removeResultFrame();
    const frame = document.createElement('iframe');
    frame.name = form.id + '-result';
    frame.title = root.dataset.resultLabel;
    frame.hidden = true;
    frame.style.display = 'none';
    frame.tabIndex = -1;
    frame.addEventListener('load', () => {
      if (attempt !== submissionId || resultFrame !== frame) return;
      try {
        const result = frame.contentDocument;
        if (!result || result.URL === 'about:blank') return;
        const confirmed = Boolean(result.querySelector(
          '#KikiSubscribePopupForm .kiki-subscribe-popup__server-success'
        ));
        removeResultFrame();
        settleSubmission(confirmed);
      } catch (error) {
        settleSubmission(false);
      }
    });
    root.appendChild(frame);
    resultFrame = frame;
    form.target = frame.name;
  };

  const submitProtectedForm = (attempt) => {
    let started = false;
    const submit = () => {
      if (started || attempt !== submissionId || submissionState !== 'pending') return;
      started = true;
      try {
        form.submit();
      } catch (error) {
        settleSubmission(false);
      }
    };
    const captchaApi = window.Shopify && window.Shopify.captcha;
    try {
      if (captchaApi && typeof captchaApi.protect === 'function') {
        captchaApi.protect(form, submit);
      } else {
        submit();
      }
    } catch (error) {
      settleSubmission(false);
    }
  };

  const submitAsync = (event) => {
    if (!form || !emailInput || !submitButton) return;
    if (submissionState !== 'idle') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!form.reportValidity()) {
      event.preventDefault();
      return;
    }

    const attempt = ++submissionId;
    try {
      const action = new URL(form.action, window.location.href);
      if (action.origin !== window.location.origin) return;
      prepareResultFrame(attempt);
    } catch (error) {
      removeResultFrame();
      form.removeAttribute('target');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    submissionState = 'pending';
    submittedThisVisit = true;
    form.dataset.kikiAsyncSubmitting = 'pending';
    form.setAttribute('aria-busy', 'true');
    emailInput.readOnly = true;
    submitButton.disabled = true;
    submitButton.textContent = root.dataset.pendingLabel;
    window.setTimeout(showAsyncSuccess, 1500);
    resultTimer = window.setTimeout(() => settleSubmission(false), 45000);
    submitProtectedForm(attempt);
  };

  if (form) {
    form.addEventListener('submit', submitAsync, { capture: true, passive: false });
    if (form.querySelector('.kiki-subscribe-popup__server-success')) markClaimed();
  }

  if (dismissedThisVisit) dismissTab();
  if (passivePage && tabWrap) {
    tabWrap.hidden = true;
    tabWrap.setAttribute('aria-hidden', 'true');
  }
  root.hidden = false;

  const scheduleAutoOpen = () => {
    if (dismissedThisVisit || suppressAutoOpen || submittedThisVisit || autoOpened || dailyLimit < 1 || dailyCount() >= dailyLimit || hasClaimed()) return;
    window.setTimeout(() => {
      if (!dismissedThisVisit && !submittedThisVisit && !hasClaimed() && dailyCount() < dailyLimit) open('auto');
    }, delay);
  };

  if (window.Shopify && Shopify.designMode) {
    return;
  }

  scheduleAutoOpen();
})();

